import { siteState } from './site.state';
import { siteActions } from './site.actions';
import { siteMutations } from './site.mutations';
import { siteGetters } from './site.getters';
import { Module } from 'vuex';
import { RootState } from '@/store/store';
import { SiteState } from './types/site.types';

export default {
  namespaced: true,
  state: siteState,
  getters: siteGetters,
  actions: siteActions,
  mutations: siteMutations,
} as Module<SiteState, RootState>;
